<div #panelEl class="divider-panel"></div>